import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { UrlService } from '../services/url/url.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private _loadingService: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipLoadingRequests = [
      '/trades/register/upload',
      '/upload-media/generate-presigned-url',
      's3.amazonaws.com',
      'uploadFileChunk',
    ];

    if (
      !this._loadingService.forceLoading &&
      skipLoadingRequests.some((urlPart) => req.url.includes(urlPart))
    ) {
      this._loadingService.hide();
    } else {
      this._loadingService.show();
    }

    return next.handle(req).pipe(
      finalize(() => {
        this._loadingService.hide();
        this._loadingService.setLoadingMessage('');
      })
    );
  }
}
